import { render, staticRenderFns } from "./KlimaUmweltschutzIcon.vue?vue&type=template&id=145f6298&scoped=true&"
var script = {}
import style0 from "./KlimaUmweltschutzIcon.vue?vue&type=style&index=0&id=145f6298&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145f6298",
  null
  
)

export default component.exports